export default {
    state: {
        openModal: ''
    },
    getters: {
        currentlyOpenModal(state) {
            return state.openModal;
        }
    },
    mutations: {
        closeAllModals(state) {
            state.openModal = null;
        },
        openModal(state, payload) {
            state.openModal = payload;
        }
    },
    actions: {
        closeAllModals(context) {
            document.body.classList.remove('modal--open');
            return context.commit('closeAllModals');
        },
        setModalOpen(context, modalName) {
            context.dispatch('closeAllModals');
            document.body.classList.add('modal--open');
            return context.commit('openModal', modalName);
        }
    }
};
